import { ModelIcon } from '../ModelIcon';
import type { PromptProviderInfo } from '../../types';

export function ProviderIcons({
  providers,
  size = 22,
}: {
  providers: PromptProviderInfo[];
  size?: number;
}) {
  if (!providers.length) {
    return <span className="fs--1 text-300">—</span>;
  }

  return (
    <div className="d-flex align-items-center gap-1">
      {providers.map((p) => (
        <span
          key={p.modelId}
          title={
            p.status
              ? `${p.publicName} · ${p.status}${p.lastRunAt ? ` · ${new Date(p.lastRunAt).toLocaleDateString()}` : ''}`
              : p.publicName
          }
          className="d-inline-flex"
        >
          <ModelIcon
            svg={p.iconSvg}
            name={p.publicName}
            size={size}
          />
        </span>
      ))}
    </div>
  );
}
